(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7553],{

/***/ 3198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 1747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SmartEditableArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _magnolia_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9647);





var EditableArea = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1341), __webpack_require__.e(7351)]).then(__webpack_require__.bind(__webpack_require__, 7351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7351)
            ];
        }
    }
});
function SmartEditableArea(props) {
    var slotNode = props.slotNode, isPreview = props.isPreview;
    if (isPreview) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditableArea, {
                className: "EditableArea",
                content: slotNode
            })
        });
    }
    var pageNodes = ((slotNode === null || slotNode === void 0 ? void 0 : slotNode["@nodes"]) || []).map(function(name) {
        return slotNode === null || slotNode === void 0 ? void 0 : slotNode[name];
    }).filter(Boolean);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: pageNodes.map(function(node) {
            var NodeComponent = (0,_magnolia_config__WEBPACK_IMPORTED_MODULE_3__/* .getComponentForMagnoliaTemplate */ .rX)(node["mgnl:template"]);
            if (!NodeComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NodeComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, node), node["@id"]);
        })
    });
}


/***/ }),

/***/ 700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ dt; }
/* harmony export */ });
/* unused harmony export FiltersGroup */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Chips_2709174d_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7759);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);







const k = "rich-text", E = "hero__text", P = "mobile", N = "tablet", S = "desktop", L = "button__text-primary", G = "button__title", F = "button__title__map", H = "button__heroTitle", w = "heading__page", A = "heading__section", O = "heading__menu", V = "texts__component_title", j = "texts__component_title--bold", M = "texts__lead_text", D = "page__lead_text", I = "texts__lead_text--bold", R = "texts__paragraph_subtitle", W = "texts__paragraph_subtitle--bold", X = "texts__body_text", q = "texts__body_text--bold", z = "texts__link", J = "texts__caption", K = "texts__caption--bold", Q = "page__heading", U = "filters", Y = "filters__content", Z = "filters__title-cont", $ = "filters__title", tt = "filters__clear", et = "filters__groups", st = "filters__group", i = {
  richText: k,
  heroText: E,
  mobile: P,
  tablet: N,
  desktop: S,
  buttonTextPrimary: L,
  buttonTitle: G,
  buttonTitleMap: F,
  buttonHeroTitle: H,
  headingPage: w,
  headingSection: A,
  headingMenu: O,
  textsComponentTitle: V,
  textsComponentTitleBold: j,
  textsLeadText: M,
  pageLeadText: D,
  textsLeadTextBold: I,
  textsParagraphSubtitle: R,
  textsParagraphSubtitleBold: W,
  textsBodyText: X,
  textsBodyTextBold: q,
  textsLink: z,
  textsCaption: J,
  textsCaptionBold: K,
  pageHeading: Q,
  filters: U,
  filtersContent: Y,
  filtersTitleCont: Z,
  filtersTitle: $,
  filtersClear: tt,
  filtersGroups: et,
  filtersGroup: st
}, m = {
  title: "Select a category",
  clearFilters: "Clear filters"
  // showResults: "Show results",
  // filters: "Filters",
}, dt = (_) => {
  const { wording: u, filters: o, changeHandler: a } = _, {
    title: r,
    clearFilters: n
    // showResults,
    // filters: filtersLabel,
  } = { ...m, ...u }, [l, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), p = (e) => {
    const { name: d, value: C } = e;
    c((y) => ({ ...y, [d]: C }));
  }, t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    c({});
  }, []);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    a && a(l);
  }, [a, l]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      as: "section",
      className: i.filters,
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      "data-testid": "filters-block"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content,
      {
        className: i.filtersContent,
        flex: !0,
        "data-testid": "filters-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: i.filtersTitleCont }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "h3",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadTextBold, i.filtersTitle),
          itemProp: "name"
        },
        r || m.title
      ), !!Object.values(l).filter((e) => !!e).length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { href: "#", tabIndex: 0, className: i.filtersClear, onClick: t }, n || m.clearFilters)),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          "data-testid": "filters-groups",
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(i.filtersGroups)
        },
        Array.isArray(o) && o.map((e, d) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          b,
          {
            key: d,
            ...e,
            onChange: p,
            initialValues: l[e.name]?.split(",") || []
          }
        )),
        !Array.isArray(o) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          b,
          {
            ...o,
            onChange: p,
            initialValues: l[o.name]?.split(",") || []
          }
        )
      )
    )
  );
}, b = ({
  name: _,
  items: u,
  onChange: o,
  isMulti: a = !1,
  initialValues: r = []
}) => {
  const [n, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(r);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    l(r);
  }, [r]);
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (t) => {
      o?.({ name: _, value: t.join(",") });
    },
    [_, o]
  ), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (t) => {
      let e;
      a ? e = n.includes(t.value) ? n.filter((d) => d !== t.value) : [...n, t.value] : e = [t.value], l(e), c(e);
    },
    [c, n, a]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { "data-testid": "filters-group", className: i.filtersGroup }, u.map((t) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Chips_2709174d_mjs__WEBPACK_IMPORTED_MODULE_3__.C,
    {
      key: t.value,
      as: "button",
      variant: "compact",
      bolder: !0,
      onClick: () => p(t),
      text: t.label,
      selected: n?.includes(t.value),
      showXWhenSelected: a
    }
  )));
};

//# sourceMappingURL=Filters.js.map


/***/ }),

/***/ 8041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ at; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8643);
/* harmony import */ var _LinkPreviewCard_2daafeaa_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4382);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7977);













const H = "lp-container--bg-auto", D = "lp-container__employer", G = "lp-container__content", W = "desktop", j = "lp-container__content-no-images", q = "lp-container", z = "button-container", t = {
  lpContainerBgAuto: H,
  lpContainerEmployer: D,
  lpContainerContent: G,
  desktop: W,
  lpContainerContentNoImages: j,
  lpContainer: q,
  buttonContainer: z
}, F = 5;
function at(c) {
  const {
    cards: n,
    hasImages: e,
    hasSaveButton: p,
    newTab: m,
    backgroundColor: C = "auto",
    ...d
  } = c, [r, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(3), g = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_1__.u)();
  if (!n.length)
    return null;
  const b = () => {
    r >= n.length || u((i) => i + F);
  }, S = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    t.lpContainerContent,
    e ? "" : t.lpContainerContentNoImages
  ), h = n.slice(0, r), k = e ? n : h;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B.Padding.LARGE,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
        t.lpContainer,
        g && t.lpContainerEmployer,
        C === "auto" && t.lpContainerBgAuto
      ),
      ...d
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B.Content, { className: S }, k.map((i, E) => {
      const {
        cardIntroText: w,
        cardTitle: B,
        imageProps: T,
        link: s,
        linkLabel: f,
        linkLocale: N,
        linkDescription: _,
        isSaved: v,
        onSave: y,
        showCTAOnMobile: P,
        newTab: I,
        hasSaveButton: L,
        badge: A
      } = i;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _LinkPreviewCard_2daafeaa_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
        {
          key: s + E,
          cardIntroText: w,
          cardTitle: B,
          imageProps: T,
          link: s,
          linkDescription: _,
          linkLocale: N,
          hasImages: e,
          hasSaveButton: L || p,
          linkLabel: f,
          isSaved: v,
          onSave: y,
          newTab: I || m,
          showCTAOnMobile: P,
          badge: A
        }
      );
    })),
    !e && r < n.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t.buttonContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Secondary,
      {
        text: "Show more",
        onClick: b
      },
      "show more"
    ))
  );
}

//# sourceMappingURL=LinkPreview.js.map


/***/ }),

/***/ 9792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);



const i = "page-header", H = "page-header--blue", m = "page-header--light-blue", u = "page-header__heading", h = "desktop", B = "page-header__lead-text", t = {
  pageHeader: i,
  pageHeaderBlue: H,
  pageHeaderLightBlue: m,
  pageHeaderHeading: u,
  desktop: h,
  pageHeaderLeadText: B
};
function E({
  heading: n,
  leadText: r,
  backgroundColor: o,
  children: g,
  className: l,
  ...s
}) {
  const c = o === "lightBlue" ? t.pageHeaderLightBlue : t.pageHeaderBlue;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      "data-testid": "page-header",
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.pageHeader, c, l),
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL,
      ...s
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.pageHeading, t.pageHeaderHeading) }, n)),
    r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitle,
          t.pageHeaderLeadText
        )
      },
      r
    )),
    g ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, g) : null
  );
}

//# sourceMappingURL=PageHeader.js.map


/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 7759:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3355);




const b = "chips", k = "chips--compact", E = "chips--bolder", I = "close-icon", o = {
  chips: b,
  chipsCompact: k,
  chipsBolder: E,
  closeIcon: I
}, i = 40;
function _(e) {
  const {
    text: c = "",
    variant: l = "standard",
    bolder: r = !1,
    clipLongText: h = !0,
    selected: s,
    showXWhenSelected: m = !1
  } = e, p = c.length > i, n = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, p && h ? `${c.slice(0, i).trim()}...` : c, m && s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__.W.CLOSE, className: o.closeIcon })), a = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    e.className,
    r ? o.chipsBolder : _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyText,
    o.chips,
    l === "compact" && o.chipsCompact
  );
  return e.as === "button" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: a,
      onClick: e.onClick,
      "aria-checked": !!s,
      role: "checkbox",
      title: c
    },
    n
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      title: c,
      href: e.href || "#",
      disableLinkTextStyle: !0,
      "aria-checked": !!s,
      role: "checkbox",
      className: a
    },
    n
  );
}

//# sourceMappingURL=Chips-2709174d.mjs.map


/***/ }),

/***/ 4382:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Y; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5905);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var _CallToAction_d24a74ed_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1416);





const N = "link-preview-card", L = "desktop", T = "image-container", S = "image", B = "badge", x = "link-wrapper", E = "preview-container", W = "preview-content", P = "card-title", f = "card-intro-text", y = "preview-link", H = "cta-hover", A = "save-button-container", M = "cta", O = "no-images-card", _ = "no-images-preview-content", R = "no-images-card-link-wrapper", D = "no-save-no-images-button-card-height", V = "no-save-button-card-link-wrapper", j = "no-save-no-images-link-wrapper", q = "no-save-button-preview-content", z = "no-save-button-cta", F = "hide-cta-on-mobile", e = {
  linkPreviewCard: N,
  desktop: L,
  imageContainer: T,
  image: S,
  badge: B,
  linkWrapper: x,
  previewContainer: E,
  previewContent: W,
  cardTitle: P,
  cardIntroText: f,
  previewLink: y,
  ctaHover: H,
  saveButtonContainer: A,
  cta: M,
  noImagesCard: O,
  noImagesPreviewContent: _,
  noImagesCardLinkWrapper: R,
  noSaveNoImagesButtonCardHeight: D,
  noSaveButtonCardLinkWrapper: V,
  noSaveNoImagesLinkWrapper: j,
  noSaveButtonPreviewContent: q,
  noSaveButtonCta: z,
  hideCtaOnMobile: F
};
function Y(l) {
  const {
    cardTitle: i,
    cardIntroText: d,
    link: m,
    linkLabel: s,
    linkLocale: p,
    imageProps: a,
    hasImages: n,
    hasSaveButton: r,
    showCTAOnMobile: v = !0,
    newTab: c = !0,
    badge: C
  } = l, k = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkPreviewCard, {
    [e.noImagesCard]: !n,
    [e.noSaveNoImagesButtonCardHeight]: !r && !n,
    [e.hideCtaOnMobile]: !v
  }), w = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkWrapper, {
    [e.noImagesCardLinkWrapper]: !n,
    [e.noSaveButtonCardLinkWrapper]: !r,
    [e.noSaveNoImagesLinkWrapper]: !n && !r
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: k, "data-testid": "link-preview-container" }, n && a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.imageContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
    {
      credits: a.credits,
      src: a.src,
      width: a.width,
      height: a.height,
      altText: a.altText,
      imageLoader: a.imageLoader,
      className: e.image,
      styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__.a.PREVIEW_CARD,
      "data-testid": "link-preview-image"
    }
  ), C && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.badge, "data-testid": "link-preview-badge" }, C)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: w }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      href: m,
      locale: p,
      "aria-label": i,
      disableLinkTextStyle: !0,
      className: e.previewLink,
      target: c ? "_blank" : void 0,
      "data-testid": "link-preview-link"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.previewContainer, "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      G,
      {
        cardIntroText: d,
        cardTitle: i,
        linkLabel: s,
        hasImages: n,
        hasSaveButton: r,
        newTab: c
      }
    ))
  )));
}
const G = (l) => {
  const { cardIntroText: i, cardTitle: d, hasImages: m, hasSaveButton: s, linkLabel: p, newTab: a } = l, n = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.previewContent, {
    [e.noImagesPreviewContent]: !m,
    [e.noSaveButtonPreviewContent]: !s
  }), r = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitleBold,
    e.cardTitle
  ), v = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText,
    e.cardIntroText
  ), c = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.cta,
    e.ctaHover,
    s ? "" : e.noSaveButtonCta
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: n, "data-testid": "link-preview" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", { className: r }, d), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: v }, i), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _CallToAction_d24a74ed_mjs__WEBPACK_IMPORTED_MODULE_4__.C,
    {
      containerClassName: c,
      as: "div",
      text: p,
      showCTAIcon: a
    }
  ));
};

//# sourceMappingURL=LinkPreviewCard-2daafeaa.mjs.map


/***/ })

}]);